const MEDIA_ITEMS = [
  {
    title: '韩漫入门指南：从零开始的韩漫之旅',
    type: '专题',
    duration: '精选合集',
    img: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20webtoon%20style%20illustration%20showing%20a%20reading%20guide%20theme%20with%20books%20and%20comic%20panels%20floating%20in%20a%20warm%20atmosphere%2C%20soft%20coral%20and%20cream%20tones%2C%20educational%20vibe%2C%20clean%20composition%2C%20editorial%20quality%2C%20no%20text%2C%20artistic%20illustration&width=800&height=500&seq=media-01&orientation=landscape',
  },
  {
    title: '2024 国漫巅峰之作大盘点',
    type: '盘点',
    duration: '编辑精选',
    img: 'https://readdy.ai/api/search-image?query=A%20stunning%20Chinese%20manhua%20style%20illustration%20with%20epic%20fantasy%20elements%20showcasing%20multiple%20characters%20in%20traditional%20Chinese%20attire%2C%20dramatic%20golden%20lighting%2C%20cinematic%20composition%2C%20cream%20background%2C%20editorial%20quality%2C%20no%20text%2C%20artistic%20promotional%20image&width=800&height=500&seq=media-02&orientation=landscape',
  },
  {
    title: '日漫冷门神作：避开热门也精彩',
    type: '推荐',
    duration: '冷门精选',
    img: 'https://readdy.ai/api/search-image?query=A%20Japanese%20manga%20style%20illustration%20with%20a%20hidden%20gem%20theme%20showing%20a%20quiet%20reading%20nook%20with%20manga%20volumes%20and%20warm%20lamp%20light%2C%20cozy%20atmosphere%2C%20soft%20golden%20tones%2C%20clean%20composition%2C%20editorial%20quality%2C%20no%20text%2C%20artistic%20illustration&width=800&height=500&seq=media-03&orientation=landscape',
  },
  {
    title: '甜到牙疼的恋爱漫画推荐',
    type: '合集',
    duration: '高糖预警',
    img: 'https://readdy.ai/api/search-image?query=A%20sweet%20romantic%20manga%20style%20illustration%20with%20soft%20pink%20cherry%20blossom%20petals%20floating%20around%20two%20characters%2C%20dreamy%20atmosphere%2C%20warm%20cream%20tones%2C%20clean%20composition%2C%20editorial%20quality%2C%20no%20text%2C%20artistic%20promotional%20image&width=800&height=500&seq=media-04&orientation=landscape',
  },
  {
    title: '熬夜必看悬疑漫画精选',
    type: '专题',
    duration: '烧脑合集',
    img: 'https://readdy.ai/api/search-image?query=A%20mysterious%20and%20atmospheric%20manga%20style%20illustration%20with%20dark%20warm%20shadow%20tones%20showing%20a%20shadowy%20figure%20in%20a%20dimly%20lit%20alleyway%2C%20suspenseful%20mood%2C%20clean%20composition%2C%20cream%20and%20deep%20brown%20background%2C%20editorial%20quality%2C%20no%20text%2C%20artistic%20promotional%20image&width=800&height=500&seq=media-05&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-2">
          精彩专题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          编辑团队为你精心策划的漫画专题合集
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {MEDIA_ITEMS.slice(0, 3).map((item) => (
            <article key={item.title} className="bg-background-50 rounded-xl overflow-hidden border border-background-200 group cursor-pointer transition-all hover:-translate-y-1">
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/30 to-transparent"></div>
                <div className="absolute top-3 left-3 px-2.5 py-1 rounded-md text-xs font-medium bg-primary-500 text-background-50 whitespace-nowrap">
                  {item.type}
                </div>
                <div className="absolute top-3 right-3 px-2.5 py-1 rounded-md text-xs font-medium bg-background-950/60 text-background-200 whitespace-nowrap">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold text-foreground-900 font-heading">{item.title}</h3>
              </div>
            </article>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
          {MEDIA_ITEMS.slice(3).map((item) => (
            <article key={item.title} className="bg-background-50 rounded-xl overflow-hidden border border-background-200 group cursor-pointer transition-all hover:-translate-y-1">
              <div className="flex flex-col sm:flex-row">
                <div className="relative w-full sm:w-56 aspect-[16/10] sm:aspect-auto overflow-hidden bg-background-100 flex-shrink-0">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="p-4 flex-1 flex flex-col justify-center">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="px-2 py-0.5 text-xs font-medium bg-primary-100 text-primary-600 rounded whitespace-nowrap">{item.type}</span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.duration}</span>
                  </div>
                  <h3 className="text-sm font-bold text-foreground-900 font-heading">{item.title}</h3>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}